<template>
    <div
        class="detailed-provider-row"
        v-if="content && this.providers.length > 0"
    >
        <template v-for="(partner, key) in this.providers">
            <div
                :key="key"
                v-if="
                    partner['provider_id'] === content &&
                    !partner['is_article_provider']
                "
                class="partner-row"
            >
                <div>
                    <a :href="gotoLink(partner)" target="_blank">
                        <h3 class="title">
                            {{ key + 1 }}. {{ partner['content']['title'] }}
                        </h3>
                    </a>
                </div>
                <br />
                <br />
                <HighlightedTopProvider
                    :highlighted-provider="partner"
                    :show-flag="key === 0"
                />
            </div>
        </template>
    </div>
</template>

<script>
import { ghostWriterRankingMixin } from '@/ghost-mixins';
import HighlightedTopProvider from '@organisms/SEOArticlePartials/partials/HighlightedTopProvider';
export default {
    name: 'DetailedProviderRow',
    mixins: [ghostWriterRankingMixin],
    components: {
        HighlightedTopProvider,
    },
    props: {
        providers: {
            type: Array,
            default: () => [],
        },
        content: {
            default: null,
        },
        partnerHeadlineTextColour: {
            type: String,
            default: '#173a68',
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

.detailed-provider-row {
    display: flex;
    flex-direction: column;

    .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 2px;
        margin-top: 4px;
        cursor: pointer;
        color: var(--gw-partner-headline-text-colour);

        &:hover {
            text-decoration-line: underline;
        }
    }

    .partner-row {
        .partner-cta-button {
            display: flex;
            width: fit-content;
            margin: 20px auto;
            color: #fff;
            background-color: #3e4a57;
            border-radius: 10px;
            justify-content: center;
            padding: 0.7rem 1.75rem;
            min-width: 160px;
            min-height: 45px;
            font-size: 17px;
            font-weight: bolder;
            box-shadow: 0 3px 3px 0 rgba(0, 105, 191, 0.1);
        }
    }
}
</style>
